import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { logout } from '../../../api'
import { LOCAL_STORAGE_NAME_TOKEN } from '../../../constants/storage'
import { useClickOutside, useInitActions, useKeyboard } from '../../../hooks'
import { destroyProductFruits } from '../../../utils/productFruits'
import { removeStorageItem } from '../../../utils/storage'
import {
  BUTTON_ARROW_CONTENT_ICON_PLACEMENT_AFTER,
  BUTTON_HEIGHT_24,
  ButtonArrow,
} from '../../Button'
import { List } from '../../List'
import { ListDivider } from '../../ListDivider'
import { ListItem } from '../../ListItem'
import { UserMenuNameNav } from '../UserMenuNameNav'
import { UserMenuThemeMode } from '../UserMenuThemeMode'

import {
  QA_NAME_USER_PROFILE_NAME,
  QA_NAME_USER_SIGN_OUT,
} from './UserMenuName.constants'

import * as styles from './UserMenuName.module.css'

function UserMenuName({ AccountLinks = UserMenuNameNav, fullname, owner }) {
  const [isOpen, setOpen] = useState(false)

  const { t } = useTranslation()

  const listRef = useRef(null)

  const { resetApp } = useInitActions()

  function handleClickOut() {
    setOpen(false)
  }

  useClickOutside(listRef, handleClickOut)

  useKeyboard(null, handleClickOut)

  function handleClick() {
    return setOpen(!isOpen)
  }

  function handelLogout() {
    logout().then(() => {
      removeStorageItem(LOCAL_STORAGE_NAME_TOKEN)

      destroyProductFruits()
      resetApp()
    })
  }

  return (
    // TODO Add lib component
    <div className={styles.wrapper} ref={listRef}>
      <ButtonArrow
        isGreySecondary
        className={styles.userName}
        getTooltip={null}
        height={BUTTON_HEIGHT_24}
        iconPlacement={BUTTON_ARROW_CONTENT_ICON_PLACEMENT_AFTER}
        isOpen={isOpen}
        qaName={QA_NAME_USER_PROFILE_NAME}
        text={fullname}
        onClick={handleClick}
      />

      {isOpen && (
        <List className={styles.list}>
          {AccountLinks ? <AccountLinks owner={owner} /> : null}
          <UserMenuThemeMode />
          <ListDivider />
          <ListItem
            qaName={QA_NAME_USER_SIGN_OUT}
            text={t('Header.SignOutBtnKey')}
            onClick={handelLogout}
          />
        </List>
      )}
    </div>
  )
}

export default UserMenuName
